<template>
  <div class="event" :class="expanded ? 'expanded' : ''">
    <button @click="toggleExpanded">></button>
    <header @click="toggleExpanded">
      <h5>{{ formattedDate }}</h5>
      <h4>{{ event.title }}</h4>
    </header>
    <div v-if="expanded" class="content">
      <h3>{{ event.title }}</h3>
      <p class="lead" v-if="event.location"><strong>{{ event.location }}</strong><br>
      <span v-if="event.time">{{ event.time }}</span></p>
      <div class="event-content" v-html="event.description"></div>
      <a :href="event.register_link" target="_blank" v-if="event.register_link" class="btn btn-lg btn-primary">Register Now</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'event',
  data () {
    return {
      expanded: this.event.expanded || false
    }
  },
  props: ['event'],
  methods: {
    toggleExpanded () {
      let vm = this
      vm.expanded = !vm.expanded
      vm.$parent.$children.forEach(function (e) {
        if (e !== vm) {
          e.expanded = false
        }
      })
    }
  },
  computed: {
    formattedDate () {
      let vm = this
      if (vm.event && vm.event.date) {
        return vm.$moment(vm.event.date).format('dddd, MMMM Do, YYYY')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  strong {
    font-weight: bold;
  }

  .event {
    border: 1px solid $dkBrown;
    margin-bottom: 1rem;
    position: relative;
    header {
      padding: 1rem 3rem;
      cursor: pointer;
      h5 {
        color: $brand-primary;
        font-weight: bold;
        text-transform: uppercase;
      }
      h4 {
        margin-bottom: 0;
      }
    }
    button {
      cursor: pointer;
      padding: 0;
      border: 0;
      background: transparent;
      font-family: $hand;
      font-size: 4rem;
      position: absolute;
      top: 1.75rem;
      right: 1.75rem;
      line-height: 20px;
      height: 20px;
      color: $ltBrown;
      transition: all 250ms;
      &:focus {
        outline: none;
      }
    }
    &.expanded {
      header {
        background-color: $dkBrown;
        border-bottom: 1px solid $dkBrown;
        color: $bgColor;
        h5 {
          color: $white;
        }
      }
      button {
        color: $gold;
        transform: rotate(90deg);
        top: 2.25rem;
        right: 1.25rem;
      }
    }
    .content {
      padding: 3rem;
    }
    .event-content {
      margin-bottom: 3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Event.vue?63a1d6a6